<template>
  <div class="container">
    <Search @search="minSearchSubmit" @reset="resetQueryParams">
      <el-form label-width="80px">
        <el-row :gutter="30">
          <el-col :span="8">
            <el-form-item label="所属省份">
              <el-select
                v-model="queryParams.provinceName"
                placeholder="请选择"
              >
                <el-option label="全部" value=""></el-option>
                <el-option
                  v-for="(item, index) in provinceList"
                  :key="index"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </Search>
    <div class="table-container">
      <el-table :data="dataList" style="width: 100%" :cell-style="renderCell">
        <el-table-column type="index" label="序号" />
        <el-table-column
          prop="articlePublishTime"
          label="文章发布时间"
          width="160px"
        />
        <el-table-column prop="provinceName" label="所属省份" width="80px" />
        <el-table-column
          prop="articleTitle"
          label="文章标题"
          show-overflow-tooltip
        />
        <el-table-column label="文章原始链接">
          <template slot-scope="scope">
            <a
              style="color: #409EFF"
              :href="scope.row.articleSourceLink"
              target="_blank"
              >{{ scope.row.articleSourceLink }}</a
            >
          </template>
        </el-table-column>
        <!-- <el-table-column prop="grabTime" label="抓取时间" width="160px" /> -->
      </el-table>
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :current-page.sync="currentPage"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        class="pagination"
      />
    </div>
  </div>
</template>

<script>
import Search from 'components/search/search';
import searchMixin from 'mixin/search';
import paginationMixin from 'mixin/pagination';
export default {
  data() {
    return {
      provinceList: [],
      queryParams: {
        provinceName: ''
      },
      areas: [],
      dialogVisible: false,
      dataList: []
    };
  },
  mixins: [paginationMixin, searchMixin],
  mounted() {
    this.loadProvinceList();
    this.querySubmit();
  },
  methods: {
    loadProvinceList() {
      this.$request({
        url: 'rest/statistic/reportData',
        data: {
          json: JSON.stringify({
            dict: {},
            pageBean: {
              pageNum: 1,
              pageSize: 1
            },
            params: {
              handlerName: 'grab_config_info',
              id: '1'
            }
          })
        }
      }).then(res => {
        const grabAreas = res.list[0].grabAreas;
        if (grabAreas) {
          this.provinceList =
            grabAreas.indexOf(',') > -1 ? grabAreas.split(',') : [grabAreas];
        }
      });
    },
    querySubmit() {
      this.$request({
        url: 'rest/statistic/reportData',
        data: {
          json: JSON.stringify({
            pageBean: {
              pageNum: this.currentPage,
              pageSize: this.pageSize
            },
            params: {
              handlerName: 'consensus_list',
              ...this.queryParams
            }
          })
        }
      }).then(res => {
        this.dataList = res ? [...res.list] : [];
        this.total = res ? res.total : 0;
      });
    },
    renderCell({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 3) {
        return { fontSize: '18px', fontWeight: 'bold' };
      }
    }
  },
  components: {
    Search
  }
};
</script>

<style lang="stylus" scoped>
.container
  padding 20px
  background #fff
  border-radius 4px
.pagination
  width 100%
  text-align right
  padding 30px 0
  background #fff
</style>
